import React, { useEffect, useState } from "react"
import { Row, Col, Card, CardBody, Button, Spinner } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next"
import { map, range } from "lodash"

import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { defaultImg } from "assets/images"

//actions

import "../../assets/scss/datatables.scss"

import MyPagination from "components/Common/MyPagination"
import DeleteModal from "components/Common/DeleteModal"
import { AvField, AvForm } from "availity-reactstrap-validation"
import moment from "moment"
import CarDeliveryModal from "./Crud/Modal"
import { deleteCarDelivery, getCarDeliveries } from "store/actions"
import { useRole, ROLE_TYPES } from "hooks/useRole"

const CarDelivery = () => {
  const { isAnyRole, canManageDelete } = useRole()
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)
  const [carDeliveryModal, setCarDeliveryModal] = useState({
    status: false,
    data: {},
  })
  const [imagesPreview, setImagesPreview] = useState([])

  const [totalItemLimit, setTotalItemLimit] = useState(() => {
    return parseInt(localStorage.getItem("carDeliveryLimit")) || 10
  })
  const { loading, carDeliveries } = useSelector(state => ({
    loading: state.CarDelivery.loading,
    carDeliveries: state?.CarDelivery?.deliveries,
  }))

  const totalPages = Math.ceil(carDeliveries?.total / totalItemLimit)
  const pages = range(1, totalPages + 1)

  useEffect(() => {
    dispatch(getCarDeliveries(page, totalItemLimit, ""))
  }, [dispatch, page, totalItemLimit])

  const [isOpen, setIsOpen] = useState({ status: false, id: "" })

  const handleDelete = id => {
    setIsOpen({ status: true, id: id })
  }

  const handleDeleteEvent = () => {
    setIsOpen({ ...isOpen, status: false })
    dispatch(deleteCarDelivery(isOpen?.id))
  }

  const columns = [
    {
      dataField: "no",
      text: "#",
      sort: true,
    },

    {
      dataField: "createdAt",
      text: "Created At",
    },
    {
      dataField: "image",
      text: "Delivery Photo",
      sort: true,
    },
    {
      dataField: "action",
      text: "Action",
    },
  ]

  const handleColumns = () => {
    if (isAnyRole([ROLE_TYPES.SALES_MANAGER])) {
      return columns?.filter(i => i.dataField !== "action")
    } else return columns
  }
  const getCompressedImage = url => {
    if (!url) return defaultImg
    return url.replace("/upload/", "/upload/f_auto,c_fill,w_110,h_70,q_30/")
  }
  const tableData = map(carDeliveries?.deliveries, (item, index) => ({
    ...item,
    no: <span>{index + 1 + (page - 1) * totalItemLimit}</span>,
    name: (
      <div style={{ whiteSpace: "break-spaces" }}>
        {item?.name?.slice(0, 110)}
        {item?.name?.length > 110 ? "..." : ""}
      </div>
    ),
    image: (
      <img
        style={{ width: "110px", height: "110px", objectFit: "cover" }}
        src={
          item?.images && item?.images[0]
            ? getCompressedImage(item?.images[0]?.url)
            : defaultImg
        }
        alt=""
        className="img-fluid  d-block"
      />
    ),
    createdAt: moment(item.createdAt).format("DD/MM/YYYY - h:mm a"),
    action: (
      <div>
        <Button
          id={`edit${index}`}
          type="button"
          color="white"
          title="Edit Car delivery"
          className="ms-1 btn"
          onClick={() => setCarDeliveryModal({ status: true, data: item })}
        >
          <i
            className="bx bx-edit-alt "
            style={{ color: "#ffa500", fontSize: "22px" }}
          />
        </Button>
        {canManageDelete() ? (
          <>
            <Button
              id={`Delete${index}`}
              title="Delete Car delivery"
              type="button"
              color="white"
              className="ms-1 btn "
              onClick={() => {
                handleDelete(item._id)
              }}
            >
              <i
                className="bx bx-trash "
                style={{
                  color: "red",
                  fontSize: "1.3rem",
                }}
              />
            </Button>
          </>
        ) : (
          ""
        )}
      </div>
    ),
  }))

  const handlePageLimit = e => {
    if (e.target.value >= 1) {
      setTotalItemLimit(parseInt(e.target.value))
      localStorage.setItem("carDeliveryLimit", e.target.value)
    }
  }

  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={isOpen?.status}
          onCloseClick={() => setIsOpen({ ...isOpen, status: false })}
          onDeleteClick={handleDeleteEvent}
        />
        {carDeliveryModal?.status && (
          <CarDeliveryModal
            onCloseClick={() => {
              setCarDeliveryModal({ status: false, data: {} })
              setImagesPreview([])
            }}
            show={carDeliveryModal?.status}
            updateData={carDeliveryModal?.data}
            setImagesPreview={setImagesPreview}
            imagesPreview={imagesPreview}
          />
        )}

        <Col className="col-12">
          <Card>
            <CardBody>
              <ToolkitProvider
                keyField="_id"
                key={"id"}
                columns={handleColumns()}
                data={tableData}
                search
              >
                {toolkitProps => (
                  <React.Fragment>
                    <div className="d-flex align-items-center justify-content-end p-1 mb-2">
                      <div>
                        <AvForm className="form-horizontal mx-2  d-flex align-items-center w-75">
                          <div className="mx-1">
                            <span className="">
                              Show
                              <i className="fas fa-sort-numeric-down-alt mx-1"></i>
                            </span>
                          </div>
                          <div className="" style={{ width: "50px" }}>
                            <AvField
                              name="pageLimit"
                              className="form-control"
                              value={totalItemLimit}
                              onChange={e => handlePageLimit(e)}
                              type="text"
                              required
                            />
                          </div>
                        </AvForm>
                      </div>

                      <Button
                        type="button"
                        color="warning"
                        className="btn-rounded   me-2 "
                        onClick={() => setCarDeliveryModal({ status: true })}
                      >
                        <i className="mdi mdi-plus me-1" />
                        New Car Delivery
                      </Button>
                    </div>

                    {loading ? (
                      <Spinner color="secondary" className="d-block m-auto" />
                    ) : (
                      <>
                        {carDeliveries?.total >= 1 ? (
                          <>
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    keyField={"id"}
                                    key={"id"}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    // selectRow={selectRow}
                                    classes={"table align-middle table-nowrap"}
                                    headerWrapperClasses={"thead-light"}
                                    {...toolkitProps.baseProps}
                                    // onTableChange={handleTableChange}
                                    // {...paginationTableProps}
                                  />
                                </div>
                              </Col>
                            </Row>

                            <MyPagination
                              totalPages={pages}
                              page={page}
                              setPage={setPage}
                            />
                          </>
                        ) : (
                          <p className="my-4 mx-3 ">No Car Delivery Photos !</p>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )}
              </ToolkitProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default CarDelivery
